import create from 'zustand'
import { TransferAgreement } from '../types'
import { fetchTransferAgreement } from '../api'

interface TransferAgreementsState {
	transferAgreements: TransferAgreement[]
	totalTransferAgreementsCount: number
	searchString: string
	setSearchString: (searchString: string) => void
	pageNumber: number
	hasTransferAgreementsInitiallyLoaded: boolean
	uploadTransferAgreementModalOpen: boolean
	setTransferAgreementModalOpen: (uploadTransferAgreementModalOpen: boolean) => void
	incrementTransferAgreementImageCount: ({
		transferAgreementId,
		incrementImageCountBy,
	}: {
		transferAgreementId: string
		incrementImageCountBy: number
	}) => void
	fetchTransferAgreements: (input?: { isInitialLoad?: boolean }) => void
	removeTransferAgreement: (transferAgreementId: string) => void
}

export const useTransferAgreementsStore =
	create<TransferAgreementsState>((set, get) => ({
		transferAgreements: [],
		totalTransferAgreementsCount: 0,
		searchString: '',
		setSearchString: (searchString: string) => set({ searchString }),
		pageNumber: 0,
		hasTransferAgreementsInitiallyLoaded: false,
		uploadTransferAgreementModalOpen: false,
		setTransferAgreementModalOpen: (uploadTransferAgreementModalOpen: boolean) => {
			set({ uploadTransferAgreementModalOpen: uploadTransferAgreementModalOpen })
		},
		incrementTransferAgreementImageCount: ({
			transferAgreementId,
			incrementImageCountBy,
		}: {
			transferAgreementId: string
			incrementImageCountBy: number
		}) => {
			const transferAgreements = get().transferAgreements
			const foundTransferAgreementIndex =
				transferAgreements.findIndex(
					(ta) => ta.transfer_agreement_id === transferAgreementId,
				)
			if (foundTransferAgreementIndex < 0) {
				return
			}
			transferAgreements[
				foundTransferAgreementIndex
			].transfer_agreement_image_count += incrementImageCountBy
			set({ transferAgreements })
		},
		fetchTransferAgreements: async (input?: {
			isInitialLoad?: boolean
		}) => {
			const state = get()

			const pageNumber = input?.isInitialLoad ? 0 : get().pageNumber

			const transferAgreementsResponse =
				await fetchTransferAgreement({
					page: pageNumber,
					perPage: 30,
					...(state.searchString
						? {
								filters: {
									photographerName: state.searchString,
								},
						  }
						: {}),
				})

			const { data } = transferAgreementsResponse.data
			const { totalItems } = transferAgreementsResponse.data.pagination

			set({
				transferAgreements: input?.isInitialLoad
					? data
					: [...state.transferAgreements, ...data],
				totalTransferAgreementsCount: totalItems,
				pageNumber: pageNumber + 1,
				hasTransferAgreementsInitiallyLoaded: true,
			})
		},
		removeTransferAgreement: (transferAgreementId: string) => {
			const transferAgreements = get().transferAgreements
			const updatedTransferAgreements = transferAgreements.filter(
				(ta) => ta.transfer_agreement_id !== transferAgreementId,
			)
			set({
				transferAgreements: updatedTransferAgreements,
				totalTransferAgreementsCount:
					updatedTransferAgreements.length,
			})
		},
	}))
